import React, { useEffect } from 'react';
import type {History, Blocker, Transition} from 'history';
import { UNSAFE_NavigationContext } from 'react-router-dom';


export const useBlocker = (blocker: Blocker , when = true): void => {
  const navigator = React.useContext(UNSAFE_NavigationContext)
    .navigator as History

  useEffect(() => {
    if(!when) return
    const unblock = navigator.block((tx: Transition) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock()
          tx.retry()
        }
      }
      blocker(autoUnblockingTx)
    })

    return unblock
  }, [navigator, blocker, when])
}